import React from 'react';
import PayStub1 from '../../../assets/img/award/pay-stub-1.png';
import PayStub2 from '../../../assets/img/award/pay-stub-2.png';
import PayStub3 from '../../../assets/img/award/pay-stub-3.png';
import SampleImagePage from './sample-image-page';

const styles = {
  card: 'w-[60%] m-10 self-stretch pl-10 pt-2 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-brand-cyan inline-flex flex-col justify-start items-start',
  title: 'justify-start text-blue text-3xl font-normal font-serif leading-10',
  introSection: 'w-[90%] self-stretch text-xl items-center',
  introSectionTitle: 'text-xl mb-2',
};

const PayStubSample = () => {
  return (
    <SampleImagePage
      cardClassName={styles.card}
      titleClassName={styles.title}
      sectionClassName={styles.introSection}
      sectionTitleClassName={styles.introSectionTitle}
      items={[
        {
          title: 'Sample One',
          src: PayStub1,
          alt: 'Pay Stub Sample 1',
          width: '90%',
          imageStyle: { marginBottom: '10px' },
        },
        {
          title: 'Sample Two',
          src: PayStub2,
          alt: 'Pay Stub Sample 2',
          width: '88.5%',
          imageStyle: { outline: '2px solid #D1D5DB', outlineOffset: '-0.2px', marginBottom: '10px' },
        },
        {
          title: 'Sample Three',
          src: PayStub3,
          alt: 'Pay Stub Sample 3',
          width: '88.5%',
          sectionClassName: 'pb-4',
          imageStyle: { outline: '1.5px solid #D1D5DB', outlineOffset: '-0.2px' },
        },
      ]}
    />
  );
};

export default PayStubSample;
